import { render, staticRenderFns } from "./sp-transfer.vue?vue&type=template&id=6887668d"
import script from "./sp-transfer.vue?vue&type=script&lang=js"
export * from "./sp-transfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports